import bluebird from 'utils/bluebird';

import { call } from '../xmAPI';

export const GETMANY_BASE = 'PLAN_INTEGRATION_LOGS_GETMANY';
export const GETMANY_START = `${GETMANY_BASE}_START`;
export const GETMANY_SUCCESS = `${GETMANY_BASE}_SUCCESS`;
export const GETMANY_FAIL = `${GETMANY_BASE}_FAIL`;

export function getMany({ planId, integrationIds }) {
  return dispatch => {
    dispatch({ type: GETMANY_START });

    return bluebird
      .map(integrationIds, integrationId =>
        call(`/webapi/xm/1/plans/${planId}/integrations/${integrationId}/logs`),
      )
      .then(payload => {
        dispatch({
          type: GETMANY_SUCCESS,
          payload,
        });
      })
      .catch(err => {
        dispatch({
          type: GETMANY_FAIL,
          payload: err,
        });
      });
  };
}
